/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";
import config from "../config/profileCard.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_MY_PROFILE } from "../graphql";
import { VApplication } from "../../../application";
import { capitalCase } from "change-case";

import { AppNavigatorService } from "../../appNavigatorService";

const getWhoamiSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.AppNavigatorService") as AppNavigatorService;
};

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IMyProfileCardMethods extends IPluginMethodMap {
  getMyProfile(args: any): Promise<any>;
}

export class MyProfileCardService implements IAgentPlugin {
  readonly methods: IMyProfileCardMethods;

  constructor() {
    this.methods = {
      getMyProfile: this.getMyProfile.bind(this),
    };
  }

  async getMyProfile(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.query({
          query: GET_MY_PROFILE,
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          console.log(`profile data`, res.data);
          const _data: any = await this.getFormattedProfile(
            res.data?.getMyProfile
          );
          return {
            ...(_data || {}),
            tweetyProps: this.formatFormProps(
              config.TWEETY_PROPS,
              res.data?.getMyProfile
            ),
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
    // return {...(config || {})}
  }

  private async getFormattedProfile(data: any) {
    let _profileInfo: any = {
      title: null,
      subtitle: null,
      image: data?.image ? data?.image : "",
      description: data?.bio,
      listItems: [
        {
          key: "email",
          title: "Email",
          subTitle: data?.email,
          icon: "https://cdn-icons-png.flaticon.com/512/2989/2989993.png",
        },
        {
          key: "phoneNumber",
          title: "Contact No.",
          subTitle: data?.primaryContactNo,
          icon: "https://i.ibb.co/ZY9vKwL/phone-call.png",
        },
      ],
      buttons: [
        {
          key: "edit",
          title: "Edit",
          color: "primary",
        },
      ],
      initialData: {
        firstName: data?.firstName,
        lastName: data?.lastName,
        avatar: data?.image,
        phoneNumber: data?.primaryContactNo,
        bio: data?.bio,
      },
    };
    if (data?.firstName || data?.lastName) {
      const _first_name = data?.firstName ? capitalCase(data?.firstName) : "";
      const _last_name = data?.lastName ? capitalCase(data?.lastName) : "";
      _profileInfo.title = `${_first_name} ${_last_name}`;
    }
    if (data?.description) {
      _profileInfo.subtitle = data?.description;
    }
    _profileInfo.profileInfo?.map((item: any, index: number) => {
      if (item?.label === "Email") {
        item.value = data?.email;
      } else if (item?.label === "Address") {
        item.value = data?.address?.addressLine1;
      } else if (item?.label === "Website") {
        item.value = data?.website;
      } else if (item?.label === "Contact No.") {
        item.value = data?.telephone;
      }
      return item;
    });
    return _profileInfo;
  }

  private formatFormProps(formProps: any, data: any) {
    let _res: any = formProps;
    _res.initialData = {
      firstName: data?.firstName,
      lastName: data?.lastName,
      phoneNumber: data?.primaryContactNo,
      avatar: data?.image,
    };

    return _res;
  }

  private async isEditEnabled() {
    const srv = getWhoamiSrv();
    const user = await srv?.whoAmI();
    console.log(`user in profile service`, user);
    let formatted = true;
    if (user?.whoami === "admin") {
      formatted = false;
    }
    return formatted;
  }
}
